module.exports = __webpack_public_path__ + "img/moukunting.483820de.jpeg";